import { FinancialModuleActionType, InvoiceReviewed } from './financial-module.types';

export class SetInvoiceReviewed {
  static readonly type = FinancialModuleActionType.SET_INVOICE_REVIEWED;
  constructor(public readonly invoiceReviewed: InvoiceReviewed) {}
}

export class SetInvoiceReviewedSuccess {
  static readonly type = FinancialModuleActionType.SET_INVOICE_REVIEWED_SUCCESS;
  constructor(public readonly invoiceReviewed?: InvoiceReviewed) {}
}

export class SetInvoiceReviewedError {
  static readonly type = FinancialModuleActionType.SET_INVOICE_REVIEWED_ERROR;
  constructor(
    public readonly error?: unknown,
    public readonly invoiceNumber?: string,
  ) {}
}

export class DeleteInvoiceFlags {
  static readonly type = FinancialModuleActionType.DELETE_INVOICE_FLAGS;
  constructor(
    public readonly invoiceNumber: string,
    public readonly flag: string,
  ) {}
}

export class DeleteInvoiceFlagsSuccess {
  static readonly type = FinancialModuleActionType.DELETE_INVOICE_FLAGS_SUCCESS;
  constructor(public readonly invoiceNumber?: string) {}
}

export class DeleteInvoiceFlagsError {
  static readonly type = FinancialModuleActionType.DELETE_INVOICE_FLAGS_ERROR;
  constructor(
    public readonly error?: unknown,
    public readonly invoiceNumber?: string,
  ) {}
}
